module.exports = __webpack_public_path__ + "static/default-user-d961d73a3082870d7e90b441c30152cf.png";